module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./collection-institutional-portal/src/widgets/widget-form-sections/widget-dfa-download/model.xml
// module id = 0
// module chunks = 19